
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: '山田 一郎',
      age: '45歳',
      location: '岡山市北区',
      content: '家族の成長に合わせて住み替えを検討していましたが、おかやま不動産販売さんのおかげで理想の家を見つけることができました。地域の情報に詳しく、とても頼りになりました。',
      image: 'https://public.readdy.ai/ai/img_res/f02f3e2e422ac7adc9284bcc2bba1b07.jpg'
    },
    {
      name: '鈴木 美香',
      age: '38歳',
      location: '岡山市中区',
      content: '初めての不動産売却で不安でしたが、スタッフの方が丁寧に説明してくださり、安心して取引を進めることができました。査定額も満足のいく金額でした。',
      image: 'https://readdy.ai/api/search-image?query=Smiling%20Japanese%20woman%20in%20her%20late%2030s%20wearing%20casual%20blouse%2C%20warm%20and%20friendly%20expression%2C%20natural%20lighting%2C%20comfortable%20home%20setting%2C%20satisfied%20customer%20appearance%2C%20genuine%20happiness%2C%20professional%20portrait&width=300&height=300&seq=customer2&orientation=squarish'
    },
    {
      name: '高橋 健太',
      age: '52歳',
      location: '岡山市南区',
      content: '急な転勤で早急に家を売却する必要がありましたが、買取サービスを利用して迅速に対応していただきました。手続きもスムーズで助かりました。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businessman%20in%20his%2050s%20wearing%20casual%20shirt%2C%20confident%20and%20satisfied%20expression%2C%20natural%20lighting%2C%20modern%20home%20background%2C%20trustworthy%20appearance%2C%20genuine%20smile&width=300&height=300&seq=customer3&orientation=squarish'
    },
    {
      name: '伊藤 恵子',
      age: '29歳',
      location: '岡山市東区',
      content: '新婚で初めてのマイホーム購入でしたが、予算や希望に合わせて多くの物件を紹介していただき、納得のいく家を購入できました。アフターフォローも充実しています。',
      image: 'https://readdy.ai/api/search-image?query=Young%20Japanese%20woman%20in%20her%20late%2020s%20wearing%20modern%20casual%20clothing%2C%20bright%20smile%2C%20happy%20expression%2C%20natural%20lighting%2C%20contemporary%20home%20setting%2C%20satisfied%20customer%20appearance%2C%20youthful%20and%20energetic&width=300&height=300&seq=customer4&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            お客様の声
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            実際にご利用いただいたお客様からの喜びの声をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center mb-2">
                    <h4 className="font-semibold text-gray-900 mr-2">{testimonial.name}</h4>
                    <span className="text-sm text-gray-500">（{testimonial.age}・{testimonial.location}）</span>
                  </div>
                  <div className="flex mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400"></i>
                    ))}
                  </div>
                  <p className="text-gray-600 leading-relaxed">{testimonial.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
